import { gql } from '@apollo/client';

export const LOGIN_AS_GUEST_MUTATION = gql`
  # Write your query or mutation here
  mutation LoginAsGuest($data: LoginByCodeInput!) {
    loginByCode(loginData: $data) {
      jwt
    }
  }
`;
